import BaseChange from "./BaseChange"

export default class LoadUrl extends BaseChange {
  constructor(url, endOfGame) {
    super()
    this.type = "loadUrl"
    this.url = url
    this.endOfGame = !!endOfGame
  }

  isLoadUrl() { return true }

}
